var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 65 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m25.312 42.027 7.466-7.467H1.845v-5.333h30.933l-7.466-7.254 3.84-3.84L43.018 32 29.152 45.867zm13.44-36.694q-2.347 0-4.907.214v5.333a59 59 0 0 1 4.907-.213q6.185 0 10.88 1.28h.213v40.106h-.213q-4.694 1.28-10.88 1.28-2.347 0-4.907-.213v5.333q2.56.213 4.907.214 4.905 0 9.173-.854 2.986-.425 5.547-1.28l1.706-.853V8.32l-1.706-.853q-2.56-.855-5.547-1.28-4.266-.855-9.173-.854"
  })));
};
export default SvgLogout;